import React from "react";
import { useParams } from "react-router-dom";
import { paths } from "../../Routes";
import { ApplicationView } from "./ApplicationView";

export function ContractView() {
  const { loanId } = useParams();
  const startPath = `${paths.Contract}/${loanId}`;
  return <ApplicationView loanId={loanId} startPath={startPath} />;
}
